import {
  WBFlex,
  WBImage,
  WBNavContainer,
} from "@apptractive/design-system-web";
import { IMG_LOGO_FULL } from "@apptractive/stm-shared";
import { ReactNode } from "react";
import { Link } from "../Link";

interface NavBarProps {
  homePath?: string;
  navRight?: ReactNode;
}

const NavBar = ({ navRight, homePath = "/" }: NavBarProps) => {
  return (
    <WBNavContainer
      elevation={1}
      color="secondary"
      sx={{ backgroundImage: "linear-gradient(135deg, #63b4f6, #78E9D3)" }}
    >
      <WBFlex justifyContent="space-between" flex={1}>
        <WBFlex flex={1} alignItems="center">
          <Link to={homePath}>
            <WBImage
              src={IMG_LOGO_FULL.default}
              alt="logo"
              sx={{ maxHeight: "58px", p: 1 }}
            />
          </Link>
        </WBFlex>

        {navRight && (
          <WBFlex flex={1} justifyContent="flex-end" alignItems="center">
            {navRight}
          </WBFlex>
        )}
      </WBFlex>
    </WBNavContainer>
  );
};

export { NavBar };
